import { atom } from 'recoil';

export const userState = atom({
  key: 'userState',
  default: {
    user_id: '',
    f_name: '',
    l_name: '',
    professionalFullName: '',
    prefix: '',
    suffix: '',
    email: '',
    state: '',
    kind: '',
    authenticated: false,
    logged_in: false,
    profile_photo: null,
    created_at: null,
    display_settings: null,
    phone: null,
    dob_legacy: null
  }
});
export const kioskState = atom({
  key: 'kioskState',
  default: { isKiosk: false, name: '', id: '', color: '' }
});
export const claimState = atom({ key: 'claimState', default: {} });
export const claimPatientState = atom({ key: 'claimPatientState', default: {} });
export const permissions = atom({ key: 'permissions', default: { loaded: false } });
export const hasBeenAuthChecked = atom({
  key: 'hasBeenAuthChecked',
  default: { checked: false, isImpersonate: false }
});
export const procedureCodeOptionsState = atom({
  key: 'procedureCodeOptionsState',
  default: []
});
export const procedureCodeMapState = atom({
  key: 'procedureCodeMapState',
  default: new Map()
});
export const roles = atom({ key: 'roles', default: { practiceId: 0, data: [] } });
export const roleOptions = atom({ key: 'roleOptionsState', default: [] });
export const professionGroupOptions = atom({ key: 'professionGroupOptionsState', default: [] });
export const settings = atom({ key: 'settings', default: {} });
export const getCodeStates = atom({
  key: 'codeStates',
  default: { cptCodes: [], modifiers: [], icdCodes: [] }
});
export const issuerState = atom({ key: 'issuerState', default: { options: [], map: {} } });
export const geographicalStatesState = atom({ key: 'geographicalStatesState', default: [] });
export const socketState = atom({ key: 'socketState', default: null });
export const socketHasConnection = atom({ key: 'socketHasConnection', default: false });
export const externalInvoiceModalState = atom({
  key: 'externalInvoiceModalState',
  default: { isOpen: false, id: null }
});
export const clinicalNote = atom({ key: 'clinicalNoteState', default: {} });
export const intelligenceAiState = atom({
  key: 'intelligenceAiState',
  default: { activeTaskIds: [], loading: false, timeoutTimeout: null, response: '', path: '' }
});
export const socketSessionTokenState = atom({ key: 'socketSessionTokenState', default: null });
export const costShareState = atom({
  key: 'costShareState',
  default: {
    deductible: { checked: false, value: 0 },
    coPayment: { checked: false, value: 0 },
    coInsurance: { checked: false, value: 0 }
  }
});
export const documentTitleOverride = atom({ key: 'documentTitleOverride', default: null });

export default {
  userState,
  kioskState,
  claimState,
  claimPatientState,
  permissions,
  hasBeenAuthChecked,
  procedureCodeOptionsState,
  procedureCodeMapState,
  roles,
  roleOptions,
  professionGroupOptions,
  settings,
  getCodeStates,
  issuerState,
  geographicalStatesState,
  socketState,
  socketHasConnection,
  externalInvoiceModalState,
  clinicalNote,
  intelligenceAiState,
  socketSessionTokenState,
  costShareState,
  documentTitleOverride
};
